import { Component } from '@angular/core';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
    selector: 'lib-cs-summary-by-fleet-business-group',
    templateUrl: './cs-summary-by-fleet-business-group.component.html',
    styleUrl: './cs-summary-by-fleet-business-group.component.css',
})
export class CsSummaryByFleetBusinessGroupComponent {
    public gridId = 151;
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Car Status Summary - Current by Fleet & Business Group Report';
    public gridSource: any[];

    constructor(public reportService: RailtracReportsService, public pageService: PageService) {}

    ngOnInit() {
        this.pageService.setHeader(this.pageHeader);
        this.gridSource = this.reportService.CreateAspNetDatastore(
            this.apiCall,
            this.gridId.toString(),
        );
    }

    onContentReady(e: any): void {
        const grid = e.component;
        let lastFleet: any = null;
        grid.getVisibleRows().forEach((row: any, index: number) => {
            if (row.rowType === 'data') {
                const cell = grid.getCellElement(index, 'fleet_id');
                if (cell) {
                    cell.textContent = row.data.fleet_id === lastFleet ? '' : row.data.fleet_id;
                }
                lastFleet = row.data.fleet_id;
            } else if (row.rowType === 'groupFooter' && lastFleet != null) {
                const cell = grid.getCellElement(index, 'fleet_id');
                if (cell) {
                    cell.textContent = `${lastFleet} Total`;
                }
            }
        });
    }
}
